import type { ConductorTask } from 'Automations/nodeDefinitions/conductor'
import type { TerminalTaskMatcher, TerminalType } from '../../simulation.types'
import { taskExecutor } from './taskExecutor'

/** The terminal a task represents, if any. */
export const matchTerminalType = ({
  task,
  terminalMatchers
}: {
  task: ConductorTask
  terminalMatchers: TerminalTaskMatcher[]
}): TerminalType | undefined =>
  terminalMatchers.find(matcher => {
    const matchesName =
      matcher.taskName === undefined || matcher.taskName === task.name
    const matchesExecutor =
      matcher.executor === undefined || matcher.executor === taskExecutor(task)

    return matcher.taskType === task.type && matchesName && matchesExecutor
  })?.terminalType
